var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVaultBulkEditTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4323 4.29353C17.6274 4.0981 17.9449 4.0975 18.1408 4.29215L19.5502 5.69325C19.7459 5.8878 19.747 6.2042 19.5522 6.39966L18.3473 7.60603L16.2377 5.49644L15.5306 6.20355L17.6408 8.31382L12.3665 13.5978C12.3068 13.6576 12.2324 13.7013 12.1511 13.7248L9.6555 14.4471C9.50433 14.4908 9.36372 14.3509 9.40691 14.1999L10.1195 11.7071C10.1428 11.6258 10.1868 11.5516 10.2466 11.4917L17.4323 4.29353Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12V17.9C18 17.9552 17.9552 18 17.9 18H6.1C6.04477 18 6 17.9552 6 17.9V6.1C6 6.04477 6.04477 6 6.1 6H12",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultBulkEditTagIcon);
export default __webpack_public_path__ + "static/media/vault-bulk-edit-tag-icon.a23e36d975b3bf778f4c31eeb8789f69.svg";
export { ForwardRef as ReactComponent };